import React, {useState, useEffect} from 'react'
import apiClient from '../api/apiClient.js'
import NameOnUploadModal from '../components/NameOnUploadModal'
import {useAuth} from '../context/AuthContext'


export default function UploadExams(){
    const {user} = useAuth()
    const schoolID = user.scId

    const [testGroups, setTestGroups] = useState([])
    const [currentTestGroup, setCurrentTestGroup] = useState(null)
    const [currentTestGroupAssignedStudents, setCurrentTestGroupAssignedStudents] = useState([])
    const [droppedFiles, setDroppedFiles] = useState([])
    const [isDragOver, setIsDragOver] = useState(false)
    const [nameOnUploadModal, setNameOnUploadModal] = useState(false)
    const [files, setFiles] = useState([])
    const [studentsWithExams, setStudentsWithExams]= useState([])

    async function fetchTestGroups(){
        try{
            const result = await apiClient.get('/api/testgroup/getall', 
                {params : {schoolID: schoolID}}
            )
            setTestGroups(result.data)
        }catch(e){
            console.log("fejl ved fetch af test groups")
            console.log(e)
        }
    }



    async function fetchTestGroupStudents(){
        try{            
            console.log(` id er ${currentTestGroup.id}`)
            
            const result = await apiClient.get('/api/testgroup/getselectablestudents', 
                {params: {testGroupID: currentTestGroup?.id || null}}
            )
/*            const result = await apiClient.get('/api/testgroup/getstudentsintestgroup', 
                {params: {testGroupID: currentTestGroup?.id || null}}
            )*/
            setCurrentTestGroupAssignedStudents(result.data)
        }catch(e){
            console.log("fejl ved kald af fetch test group")
            console.log(e)
        }
    }

    async function fetchStudentsWithExams(){
        try{
            const result = await apiClient.get('/api/testgroup/getstudentswithexams',
                {params: {testGroupID: currentTestGroup?.id || null}}
            )
            setStudentsWithExams(result.data)
            console.log(result.data)
        }catch(e){
            console.log(" error in getting students with exams")
            console.log(e)
        }
    }

    function handleDragOver(e){
        e.preventDefault()
        setIsDragOver(true)
    }

    function handleDragLeave(e){
        e.preventDefault()
        setIsDragOver(false)
    }

    async function handleDrop(e){
        e.preventDefault()
        setIsDragOver(false)
        setNameOnUploadModal(true)
        setFiles(Array.from(e.dataTransfer.files).filter(
            f => f.type === 'application/pdf'
        ))

    }

/*     function removeFile(index){
        setDroppedFiles(prev => prev.filter((_, i) => i !== index))
    } */

    useEffect(()=>{
        fetchTestGroups()
        fetchTestGroupStudents()
        fetchStudentsWithExams()
    }, [currentTestGroup, nameOnUploadModal])


    async function handleNameUpload(params){
        const {studentID, testGroupID} = params;
        console.log(`bent ${studentID}, ${testGroupID}` )
        if(files?.length > 0){
            console.log("uploading file")
        
            try{

                // note if upload to testgroup, the studentID is null
                const formData = new FormData()
                formData.append('file', files[0])
                formData.append('studentID', studentID)
                formData.append('testGroupID', testGroupID)
                const result = await apiClient.post('/api/uploadfile', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                })

            }catch(e){
                console.log("fejl ved fil upload")
                console.log(e)
            }
            setDroppedFiles(prev => [...prev, ...files])
        }
    
        //                handleNameUpload({studentID: selectedStudent.id, testGroupID: testGroupID})

    }

    async function handleDownload(thisFilename){
        try{
            const result = await apiClient.get('/api/downloadfile', {
                params: {filename: thisFilename}, 
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(result.data)
            const a = document.createElement('a')
            a.href = url
            a.download = thisFilename
            a.click()
            window.URL.revokeObject(url)
        }catch(e){
            console.log("fejl ved download af " + thisFilename)
            console.log(e)
        }
    }


    return(
        <div className="panel-container">
            <div className="panel">
                <select onChange={(e) => setCurrentTestGroup(testGroups.find(s=> s.id === parseInt(e.target.value)))}>
                    <option key="0" value={null}>Ingen prøvegruppe valgt</option>
                    {testGroups.map(testGroup=>{
                        return(
                            <option key={testGroup.id} value={testGroup.id}>{testGroup.navn}</option>
                        )
                    })}
                </select>
                <span>
                    <b>Testgruppe: </b>{currentTestGroup?.navn} 
                </span>
                {currentTestGroupAssignedStudents.length === 0 ? 
                (
                    <p className="drop-zone-hint">Ingen kursister i prøvegruppe</p>
                ):(
                    <table className="censor-table">
                        <thead>
                            <tr>
                                <th style={{width: '35%'}}>Fornavn(e)</th>
                                <th style={{width: '35%'}}>Efternavn</th>
                                <th style={{width: '30%'}}>Studie</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentTestGroupAssignedStudents.map(student => (
                                <tr>
                                    <td>{student.fornavne}</td>
                                    <td>{student.efternavn}</td>
                                    <td>{student.studie}</td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                )}
            </div>
            <div className="panel">
                <div
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{
                        border: isDragOver ? '2px dashed #4a90d9' : '2px dashed #ccc',
                        backgroundColor: isDragOver ? '#e8f0fe' : '#fafafa',
                        borderRadius: '8px',
                        padding: '40px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                    }}
                >   
                    <p style={{margin: 0, color: '#666'}}>
                        Træk PDF-filer hertil
                    </p>
                </div>
                <span>
                    <b>Besvarelser uploaded til testgruppen: </b> 
                </span>
                {currentTestGroup?.examupload_filenames?.length ===0 ? (
                    <p>Ingen file uploaded</p>
                ):(
                    <table className="censor-table" style={{marginTop: '16px'}}>
                        <thead>
                            <th>Filnanv</th>
                            <th style={{widht: '80px'}}>Fjern</th>
                        </thead>
                        <tbody>
                            {currentTestGroup?.examupload_filenames?.map(file => (
                                <tr key={file}>
                                    <td>{file}</td>
                                    <td>
                                        <button onClick={()=> console.log("file not removed. this is just a console.log")}>Fjern</button>
                                    </td>
                                    <td>
                                        <button onClick={() => handleDownload({file})}>Download</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                {studentsWithExams.length > 0 && (
                    <table className="censor-table" style={{marginTop: '16px'}}>
                        <thead>
                            <tr>
                                <th>Filnavn</th>
                                <th style={{width: '80px'}}>Fjern</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentsWithExams.map(student => (
                                <tr key={student.id}>
                                    <td>{student.fornavne}</td>
                                    <td>{student.efternavne}</td>
                                    <td>{student.examupload_filename}</td>
                                    <td>
                                        <button onClick={() => console.log("file not removed. this is just a console.log")}>Fjern</button>
                                    </td>
                                    <td>
                                        <button onClick={()=> handleDownload(student.examupload_filename)}>Download</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            { nameOnUploadModal &&
                <NameOnUploadModal 
                    testGroupID = {currentTestGroup.id}
                    handleNameUpload = {handleNameUpload}
                    onClose ={()=> setNameOnUploadModal(false)} 
                />                
            }
        </div>
    )
}